import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import {
  competitorsSnapshotDocOctoberKeys,
  competitorsSnapshotKeys,
  IELTFinancialData,
  revenueSnapshotKeys,
  TCompetitorsSnapshot,
  TCompetitorsSnapshotKeys,
  TRevenueSnapshots,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const separateFinancialData = (data: IELTFinancialData | null, eltType: EltType) => {
  if (!data) {
    return { revenueSnapshots: null, competitorsSnapshots: null }
  }
  const revenueSnapshots = revenueSnapshotKeys.reduce((acc: TRevenueSnapshots, key) => {
    return { ...acc, [key]: data[key] || {} }
  }, {} as TRevenueSnapshots)

  const compSnapshotKeys: readonly TCompetitorsSnapshotKeys[] =
    eltType === EltType.DocOctober25 || eltType === EltType.DocJanuary26
      ? competitorsSnapshotDocOctoberKeys
      : competitorsSnapshotKeys

  const competitorsSnapshots = compSnapshotKeys.reduce((acc: TCompetitorsSnapshot, key) => {
    return { ...acc, [key]: data[key] || {} }
  }, {} as TCompetitorsSnapshot)

  return { revenueSnapshots, competitorsSnapshots }
}
